import apiClient from './client';

// ─── Meine Einladungen ──────────────────────────────────────────────────────
//
// Die Gegenseite zur Mitgliederverwaltung: hier steht, wozu ICH eingeladen
// wurde. Bewusst ohne Stammbaum-Bezug – wer eingeladen ist, ist in dem Baum
// noch nicht Mitglied, und der X-Tree-Id-Header hätte hier nichts zu suchen.

export interface OffeneEinladung {
  id: string;
  baumName: string;
  rolleName: string;
  einladerEmail: string | null;
  eingeladenAm: string;
  gueltigBis: string;
}

/** Was hinter einem Einladungslink steckt. */
export interface EinladungsDetails {
  baumName: string;
  rolleName: string;
  einladerEmail: string | null;
  gueltigBis: string;
}

export async function listeEinladungen(): Promise<OffeneEinladung[]> {
  const { data } = await apiClient.get<{ data: OffeneEinladung[] }>('/einladungen');
  return data.data;
}

export async function ladeEinladung(token: string): Promise<EinladungsDetails> {
  const { data } = await apiClient.get<EinladungsDetails>(
    `/einladungen/${encodeURIComponent(token)}`,
  );
  return data;
}

export async function nimmEinladungAn(
  token: string,
): Promise<{ treeId: string; baumName: string }> {
  const { data } = await apiClient.post<{ treeId: string; baumName: string }>(
    `/einladungen/${encodeURIComponent(token)}/annehmen`,
  );
  return data;
}

export async function lehneEinladungAb(token: string): Promise<void> {
  await apiClient.post(`/einladungen/${encodeURIComponent(token)}/ablehnen`);
}
